import { I18n } from 'i18n-js';
import sbVerbiage from '@simplybenefits/sb-verbiage';
const i18n = new I18n({
  en: sbVerbiage.translations.english,
  fr: sbVerbiage.translations.french
});
i18n.locale = "en"; // TODO: change this back to Localization.locale;
i18n.fallbacks = true;
i18n.toggleLocale = () => {
  i18n.locale = i18n.locale === 'en' ? 'fr' : 'en';
};
i18n.setLocale = locale => {
  i18n.locale = locale;
};
export default i18n;